import { Stack, Typography } from '@mui/material'
import React from 'react'

import PageSection from 'components/common/PageSection'
import { useGetSharedAssets } from 'queries/sharedAssets/use-get-shared-assets'

export const ClustersPage: React.FC = () => {
  const {
    data: sharedAssets,
    isLoading: isLoadingSharedAssets,
    isError: isErrorSharedAssets,
    error: sharedAssetsError
  } = useGetSharedAssets()

  return (
    <PageSection
      errorMessage={sharedAssetsError}
      hasError={isErrorSharedAssets}
      isLoading={isLoadingSharedAssets}
    >
      {sharedAssets && (
        // TODO: useFlexGap
        <Stack sx={{ rowGap: 4 }}>
          <Typography>Clusters Page Placeholder Text</Typography>
          <Typography>Clusters List Placeholder</Typography>
        </Stack>
      )}
    </PageSection>
  )
}
